import {useState} from "react";
import styled from "styled-components";

interface PaneData {
    name: string;
    render: () => React.ReactNode;
}

interface Props {
    panes: PaneData[];
}

const PaneContainer = styled.div`
    
    .content {
        min-height: 10rem;
        min-width: 50rem;
        max-height: 50rem;
        overflow-y: auto;
        background-color: var(--content-box-border);
    }
    
    .pane-button {
        background-color: var(--accent-blue-hover);
        cursor: pointer;
        color: white;
        outline: none;
        border: none;
        padding: .5rem;
        border-top-left-radius: 5px;
        border-top-right-radius: 5px;
        transition: background-color 0.25s ease-in-out;
        &.active {
            background-color: var(--content-box-border);
        }
    }
`;

export default function Pane({panes}: Props) {

    const [activePane, setActivePane] = useState<number>(0);

    return (
        <PaneContainer>
            <div className={'header'}>
                {panes.map((pane, index) => (
                    <button
                        key={index}
                        className={`pane-button ${activePane === index ? 'active' : ''}`}
                        onClick={() => setActivePane(index)}
                    >
                        {pane.name}
                    </button>
                ))}
            </div>
            <div className="content">
                {panes[activePane].render()}
            </div>
        </PaneContainer>
    );
}

